import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';

import Slider from './slider';
import RecommendNav from './recommendNav';

import BrandsTitle from './brandsTitle';
import Brands from './brands';
import TopicFengVideo from './topicFengVideo';
import TopicNews from './topicNews';
import TopicSociety from './topicSociety';
import TopicEntertainment from './topicEntertainment';
import TopicMilitary from './topicMilitary';
import TopicHumanity from './topicHumanity';
import TopicTech from './topicTech';

import BrandsLeague from './brandsLeague';
import HotTopic from './hotTopic';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        contentAd: PropTypes.object,
    };

    render() {
        const {
            slideData,
            recommend,
            moreRecommend,
            brandsRec,
            brandsRecNav,
            fengRec,
            fengVideos,
            newsRec,
            newsVideos, // 时政抓取
            societyRec,
            societyVideos, // 社会抓取
            entertainmentRec,
            entVideos,
            militaryRec,
            militaryVideos, // 军事抓取
            humanityRec,
            artAndCultureVideos, // 艺术文化抓取
            techRec,
            techVideos, // 科技抓取
            brandsLeague,
            hotTopics,
        } = this.props.content;

        const recommendData = {
            recommend,
            moreRecommend,
        };
        const {
            banner01Ad,
            banner02Ad,
            banner03Ad,
            rectangle01Ad,
            rectangle02Ad,
            rectangle03Ad,
            slideAd,
            streamSoft01Ad,
            streamSoft02Ad,
            streamSoft03Ad,
            streamSoft04Ad,
            streamSoft05Ad,
            streamSoft06Ad,
            streamSoft07Ad,
            brandsRecAd,
        } = this.props.contentAd;

        return (
            <div className={styles.content}>
                {/* 轮播图 */}
                {slideData && slideData.length ? (
                    <Chip
                        id="75167"
                        type="recommend"
                        title="视频首页-焦点图"
                        groupName="正文"
                        translate="handleVideoSlideData"
                        content={slideData}>
                        <Slider ad={slideAd} />
                    </Chip>
                ) : null}
                {/* 推荐导航 */}
                <RecommendNav content={recommendData} />
                <div className={`${styles.top_content} clearfix`}>
                    <div className={styles.leftPart}>
                        <BrandsTitle content={brandsRecNav} />
                        {/* 品牌精选 */}
                        <Chip
                            id="75168"
                            type="recommend"
                            title="视频首页-品牌精选"
                            groupName="正文"
                            content={brandsRec}>
                            <Brands adData={brandsRecAd} />
                        </Chip>
                        {/* 风视频 */}
                        <TopicFengVideo content={fengRec} stream={fengVideos} />
                        <Ad content={banner01Ad} />
                        {/* 资讯 */}
                        <TopicNews content={newsRec} stream={newsVideos} />
                        <Ad content={banner02Ad} />
                        {/* 社会 */}
                        <TopicSociety content={societyRec} stream={societyVideos} />
                        <Ad content={banner03Ad} />
                        {/* 娱乐 */}
                        <TopicEntertainment content={entertainmentRec} stream={entVideos} ad={streamSoft01Ad} />
                        {/* 军事 */}
                        <TopicMilitary content={militaryRec} stream={militaryVideos} ad={streamSoft02Ad} />
                        {/* 人文 */}
                        <TopicHumanity content={humanityRec} stream={artAndCultureVideos} ad={streamSoft03Ad} />
                        {/* 科技 */}
                        <TopicTech content={techRec} stream={techVideos} ad={streamSoft04Ad} />
                    </div>
                    <div className={styles.rightPart}>
                        <BrandsLeague content={brandsLeague} />
                        <div className={styles.rectangle01Ad}>
                            <Ad content={rectangle01Ad} />
                        </div>
                        <HotTopic content={hotTopics} />

                        <div className={styles.rectangle02Ad}>
                            <Ad content={rectangle02Ad} />
                        </div>
                        <div className={styles.rectangle03Ad}>
                            <Ad content={rectangle03Ad} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
